import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { comapanyNameToClass } from "../../common/helper";
import { searchService } from "../../services/searchService";
import "./Search.scss";

function closeDropdown(setDropdown) {
  const dropClose = document.querySelector(".dropdown-menu");
  document.addEventListener("click", () => {
    if (dropClose.classList.contains("show")) {
      dropClose.classList.remove("show");
      setDropdown(false);
    }
  });
}

export default function Search({ company }) {
  const { t } = useTranslation();
  const [resultList, setResultList] = useState([]);
  const [dropdwon, setDropdown] = useState(false);
  const [searchText, setSearchText] = useState("");
  const history = useHistory();

  function redirect(result) {
    let refresh = false;
    setResultList([]);
    setDropdown(false);
    switch (result.type) {
      case "Interview":
        if (window.location.pathname.indexOf("interview/view") > -1)
          refresh = true;
        history.push(`/interview/view/${result.id}`);

        break;
      case "PreCandidate":
        if (window.location.pathname.indexOf("precandidate") > -1)
          refresh = true;
        history.push(`/precandidate?precandidateId=${result.id}`);

        break;
      default:
        break;
    }
    if (refresh) history.go();
  }

  function onChange({ target }) {
    if (target.value.length > 0) {
      setSearchText(target.value);
    } else {
      setDropdown(false);
    }
  }

  function search() {
    searchService.search(searchText).then((data) => {
      setResultList(data);
      setDropdown(true);
    });
    closeDropdown(setDropdown);
  }

  const handleKeypress = (e) => {
    if (e.charCode === 13) {
      search();
    }
  };

  function beeColorText() {
    if (company === "Bee" || company === "AGAP2IND") {
      return "bee-color-text";
    } else {
      return "";
    }
  }

  return (
    <div class="dropdown ml-5 position-searchbar">
      <div class="input-group">
        <input
          type="text"
          class={`searchbar ${comapanyNameToClass(company)} ${beeColorText(
            company
          )} dropdown-toggle border-field`}
          placeholder={t("Search pre candidates or interviews")}
          aria-label={t("Search pre candidates or interviews")}
          aria-describedby="basic-addon2"
          onChange={onChange}
          onKeyPress={handleKeypress}
        />
        <div class="input-group-append">
          <button
            class={`btn btn-outline-secondary ${beeColorText(
              company
            )} btnSearch`}
            type="button"
            onClick={() => search()}
          ></button>
        </div>
      </div>

      <div
        className={`dropdown-menu ${dropdwon && "show"}`}
        aria-labelledby="searchDropDown"
        style={{ marginLeft: "50px" }}
      >
        <table
          className={`table ${comapanyNameToClass(
            company
          )}-color-bg ${comapanyNameToClass(company)}-color-fg table-hover`}
        >
          <tbody>
            {resultList.length === 0 ? (
              <p className="width-table">{t("No results found.")}</p>
            ) : (
              resultList.map((result, index) => (
                <tr
                  className="dropdown-item  text-nowrap"
                  onClick={() => redirect(result)}
                  key={index}
                >
                  {" "}
                  <td>{result.type}</td>
                  <td>{result.role}</td>
                  <td width="400px" className="text-truncate second">
                    {t(result.description)}
                  </td>
                  <td>{moment(result.date).format("DD-MM-YYYY")}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
